import React from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp, FaEnvelope, FaPhone, FaMapMarkerAlt, FaFacebook, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-[#2E368F] text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16">
          {/* Company Info */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_farm-water-solutions/artifacts/8alr8q1d_image.png"
              alt="Ganga Irrigation"
              className="h-28 w-auto mb-8"
            />
            <p className="text-white/80 text-sm leading-relaxed mb-6">
              Ganga Irrigation is a trusted manufacturer of quality irrigation and agricultural products, delivering durable, water-efficient solutions that enhance crop productivity and support sustainable farming.
            </p>
            <div className="flex gap-4">
              <a 
                href="#" 
                className="text-white/70 hover:text-white transition-all duration-250 hover:-translate-y-1" 
                aria-label="Facebook"
              >
                <FaFacebook className="text-2xl" />
              </a>
              <a 
                href="#" 
                className="text-white/70 hover:text-white transition-all duration-250 hover:-translate-y-1" 
                aria-label="Instagram"
              >
                <FaInstagram className="text-2xl" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-6 text-white">Quick Links</h3>
            <ul className="space-y-3">
              {[
                { to: '/', label: 'Home' },
                { to: '/about', label: 'About Us' },
                { to: '/products', label: 'Products' },
                { to: '/services', label: 'Services' },
                { to: '/gallery', label: 'Gallery' },
                { to: '/blog', label: 'Blog' },
                { to: '/contact', label: 'Contact' }
              ].map((link) => (
                <li key={link.to}>
                  <Link 
                    to={link.to} 
                    className="text-white/70 hover:text-white transition-all duration-250 hover:translate-x-1 inline-block"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="font-semibold text-lg mb-6 text-white">Our Products</h3>
            <ul className="space-y-3 text-white/70 text-sm">
              <li>Drip Tapes</li>
              <li>Inline Drippers</li>
              <li>HDPE Pipes</li>
              <li>Filters & Valves</li>
              <li>Fittings & Connectors</li>
              <li>Complete Kits</li>
              <li>Accessories</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-lg mb-6 text-white">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <FaPhone className="text-[#6ABD45] mt-1 flex-shrink-0" />
                <div>
                  <a href="tel:+919448650161" className="text-white/80 hover:text-white transition-colors duration-250">
                    +91 9448650161
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <FaWhatsapp className="text-[#6ABD45] mt-1 flex-shrink-0" />
                <div>
                  <a 
                    href="https://wa.me/919448650161" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-white/80 hover:text-white transition-colors duration-250"
                  >
                    WhatsApp Us
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <FaEnvelope className="text-[#6ABD45] mt-1 flex-shrink-0" />
                <div>
                  <a href="mailto:info@gangairrigation.com" className="text-white/80 hover:text-white transition-colors duration-250">
                    info@gangairrigation.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <FaMapMarkerAlt className="text-[#6ABD45] mt-1 flex-shrink-0" />
                <div className="text-white/80 text-sm leading-relaxed">
                  GANGA IRRIGATION<br />
                  Plot No 233, Nandur Kesaratagi Industrial Area<br />
                  Kalaburagi, Kalaburagi<br />
                  Kalaburagi, KARNATAKA 585105<br />
                  India
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-16 pt-8 text-center text-white/60 text-sm">
          <p>&copy; {new Date().getFullYear()} Ganga Irrigation. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
